/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { createApi } from "@reduxjs/toolkit/query/react";

import { transformResponse } from "common/util";
import { dynamicBaseQuery } from "store/api/utils/dynamicBaseQuery";

export const authenticationApi = createApi({
    baseQuery: dynamicBaseQuery,
    reducerPath: "authenticationApi",
    endpoints: (builder) => ({
        driverId: builder.query<any, { url: string }>({
            query: ({ url }) => ({
                url,
            }),
            transformResponse,
        }),
    }),
});

export const { useLazyDriverIdQuery } = authenticationApi;
